<template>
<div class="main">
  <div class="topSearch">
    <div>
      <el-input placeholder="Search" v-model="input3" class="input-with-select" id="topInput">
        <el-select v-model="select" slot="prepend" style="width: 100px">
          <el-option label="Code" value="code"></el-option>
          <el-option label="Name" value="name"></el-option>
          <el-option label="Phone" value="phone"></el-option>
          <el-option label="Address" value="address"></el-option>
        </el-select>
      </el-input>
    </div>
    <div>
      <el-button type="success" round @click="getList"  style="width: 80px;padding: 0">Search</el-button>
      <el-button plain @click="clearSearch" style="width: 80px;" class="changeFocus">Clear</el-button>
    </div>
  </div>
  <div class="secoundBton"  v-loading="loading">
    <el-button type="primary" round @click="addNewDialog = true;title='Create New Address by Code'" style="margin-right: 16px">NEW</el-button>
<!--    <el-scrollbar style="height: calc(100vh - 290px)"  >-->
      <div class="innerTable" v-if="tableData.length!=0">
        <el-table
          :data="tableData"
          style="width: 100%;font-weight: normal;">
          <el-table-column
            header-align="center"
            align="center"
            prop="code"
            label="Code"
            min-width="20%"
          >
          </el-table-column>
          <el-table-column
            prop="recipient_name"
            label="Name"
            min-width="45%"
          >
          </el-table-column>
          <el-table-column
            prop="phone"
            label="Phone"
            min-width="30%"
          >
          </el-table-column>
          <el-table-column
            prop="address_desc"
            label="Address"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            prop="actions"
            width="120"
            label="Actions">
            <template slot-scope="scope">
              <div class="action">
              <span  @click="handleEdit(scope.$index, scope.row)">
              <img src="../assets/image/edit@2x.png" alt="">
              </span>
                <span  @click="handleDelete(scope.$index, scope.row)">
              <img src="../assets/image/delete@2x.png" alt="">
              </span>
                <span @click="copeAddress(scope.$index,scope.row)">
              <img src="../assets/image/clone@2x.png" alt="">
              </span>
              </div>
            </template>
          </el-table-column>
        </el-table>

      </div>
<!--      </el-scrollbar>-->
    <div v-else class="empty">
      <div>
        <img src="../assets/image/list_blank.png" alt="">
        <h2 style="color: #CCCCCC;font-size: 16px">No items found</h2>
      </div>
    </div>
    <div class="btom">
      <div class="innerLeft">1 - <span>{{tableData.length}}</span> of <span>{{total}}</span> items</div>
      <div>
        <!--          @size-change="handleSizeChange"-->
        <!--          @current-change="handleCurrentChange"-->
        <!--          :current-page.sync="currentPage3"-->
        <el-pagination
          :page-size="10"
          layout="prev, pager, next, jumper"
                  @current-change="handleSizeChange"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>

<!--  删除弹框-->
  <el-dialog
    :close-on-click-modal="false"
    title="Delete Address"
    :visible.sync="dialogVisible"
    width="30%">
    <div style="margin-top: 24px">The address with code {{code}} will be permanently deleted.</div>
    <span slot="footer" class="dialog-footer">
     <el-button type="danger" @click="dialogVisible = false" plain>Cancel</el-button>
    <el-button type="primary" @click="deleteSuccess">Delete</el-button>
  </span>
  </el-dialog>
<!--  新增弹框-->
  <el-dialog
    :close-on-click-modal="false"
    :title="title"
    :visible.sync="addNewDialog"
    @close="cancelForm"
    width="40%">
    <div style="text-align: left">
      <el-form :model="form" label-position="top" :rules="rules" status-icon ref="ruleForm" :status-icon="true" :show-message="false">
        <el-form-item label="Code" :label-width="formLabelWidth" prop="passward" >
          <el-input v-model="form.passward"  placeholder="Code" autocomplete="off" id="allInput"></el-input>
          <div slot="error"></div>
        </el-form-item>
        <el-form-item label="Contact Details" :label-width="formLabelWidth" required>
          <contact-input ref="contactPart"></contact-input>
        </el-form-item>
        <el-form-item label="Destination" :label-width="formLabelWidth" required>
          <compose-input ref="composePart"></compose-input>
        </el-form-item>
      </el-form>

    </div>
    <span slot="footer" class="dialog-footer">
     <el-button type="danger" @click="cancelForm" plain>Cancel</el-button>
    <el-button type="primary" @click="saveAdd">Save</el-button>
  </span>
  </el-dialog>
</div>
</template>

<script>
import composeInput from "@/components/composeInput";
import contactInput from "@/components/contactInput";
import {addNew, deleteNew, EditNew, getAddressList} from "@/api/addressBook";
export default {
  name: "addressBook",
  components:{
    composeInput,contactInput
  },
  created() {
    this.getList()
  },
  computed: {
    store() {
      return this.$store.state.store
    }
  },
  watch: {
    store: {
      deep: true,
      handler: function (n, o) {
        // if (n != '') {
          // 当state.avatar值发生改变，就执行这个方法
          this.getList()
        // }else if (n!=o){
        //   this.getList()
        // }
      },
    },
  },

  data(){
    return{
      organization_id:'',
      loading:false,
      input3:'',
      select:'code',
      title:"Create New Address by Code",
      tableData:[],
      dialogVisible:false,
      code:'',
      addNewDialog:false,
      id:'',
      form:{
        passward:'',
        phone:'',
        select:'',
      },
      formLabelWidth: '120px',
      rules: {
        passward: [
          { required: true, message: '', trigger: 'blur' },
        ],
      },
      page:1,
      total:0,
    }
  },
  methods:{
    getList(){
      this.loading = true
      getAddressList({
        page:this.page,
        limit:10,
        keyword:this.select,
        keyvalue:this.input3,
        order:'time desc',
        sub_organization_id:this.$store.state.store,
      }).then(res=>{
        this.loading = false
        if (res.code == 200){
          if (res.data.length == 0){
           this.tableData = []
           this.total = 0
          }else {
            this.tableData = res.data.data
            this.total = res.data.count
          }
        }else {
          this.$message({
            message: res.msg,
            type: 'error'
          });
        }
      }).catch(err=>{
        this.$message({
          message: 'err.msg',
          type: 'error'
        });

      })
    },
    handleDelete(index,row){
      this.dialogVisible = true
      this.id = row.id
      this.code = row.code
    },
    handleEdit(index,row){
      this.addNewDialog = true
      this.title = 'Edit Address by Code'
      this.$nextTick(()=>{
        this.$refs.contactPart.form.phone = row.phone
        this.id = row.id
        this.$refs.composePart.changeForm.address= row.address
        this.$refs.contactPart.form.recipient_name = row.recipient_name
        this.form.passward = row.code
        this.$refs.composePart.changeForm.city = row.city
        this.$refs.composePart.changeForm.abs = row.abs
        this.$refs.composePart.changeForm.postcode = row.postcode
      })
    },
    //删除
    deleteSuccess(){
      this.dialogVisible = false
      deleteNew({
        id:this.id,
        sub_organization_id:this.$store.state.store
      }).then(res=>{
        if (res.code == 200){
          this.getList()
          this.$message({
            message: 'Address has been deleted',
            type: 'success'
          });
        }else {
          this.$message({
            message: res.msg,
            type: 'error'
          });
        }
      })
    },
    //清除搜索条件
    clearSearch(){
      this.select = 'code'
      this.input3 = ''
      this.getList()
    },
    validateForm() {
      let flag = false
      this.$refs['ruleForm'].validate((valid) => {
        flag = valid
      })
      return flag
    },
    //新增
    saveAdd(){
      //判断是否为空
      let address = this.$refs.composePart.changeForm.address
      let abs = this.$refs.composePart.changeForm.abs
      let city = this.$refs.composePart.changeForm.city
      let postcode =  this.$refs.composePart.changeForm.postcode
      let province =  this.$refs.composePart.changeForm.province
      let recipient_name = this.$refs.contactPart.form.recipient_name
      let phone = this.$refs.contactPart.form.phone
      let valid1= this.$refs.contactPart.validateForm()
      let valid2 =this.$refs.composePart.validateForm()
      this.validateForm()
      if (this.form.passward == '' || !valid1 || !valid2){
          this.$message({
            message: 'Some information missing',
            type: 'warning'
          });
      }else {
        let form= {
          address: address,
          abs: abs,
          city: city,
          postcode: postcode,
          recipient_name: recipient_name,
          phone: phone,
          code:this.form.passward,
          province:province,
          sub_organization_id:this.$store.state.store
        }
        if (this.title == 'Create New Address by Code' || this.title == 'Cope Address'){
          addNew(form).then(
            res=>{
              if (res.code == 200){
                this.getList()
                this.addNewDialog = false
                this.$message({
                  message: 'Added successfully',
                  type: 'success'
                });
                this.clearForm()
              }else {
                this.$message({
                  message: res.msg,
                  type: 'error'
                });
              }
            })
        } else  {
          form.id = this.id
          EditNew(form).then(res=>{
            if (res.code == 200){
              this.addNewDialog = false
              this.getList()
              this.$message({
                message: 'Edited successfully',
                type: 'success'
              });
              this.clearForm()
            }else {
              this.$message({
                message: res.msg,
                type: 'error'
              });
            }
          })
        }
      }
    },
    clearForm(){
      this.$refs.ruleForm.clearValidate()
      this.$refs.ruleForm.resetFields()
      this.form.passward = ''
      this.$refs.composePart.changeForm.abs =''
      this.$refs.composePart.validateClear()
      this.$refs.contactPart.validateClear()
    },
    cancelForm(){
      this.clearForm()
      this.addNewDialog = false
    },
    handleSizeChange(val){
      this.page = val
      this.getList()
    },
    //复制address
    copeAddress(i,row){
      this.addNewDialog = true
      this.title = 'Cope Address'
      this.$refs.contactPart.form.phone = row.phone
      this.id = row.id
      this.$refs.composePart.changeForm.address = row.address
      this.$refs.contactPart.form.recipient_name = row.recipient_name
      this.$refs.composePart.changeForm.city = row.city
      // this.$refs.composePart.changeForm.input2 = row.abs
      this.$refs.composePart.changeForm.postcode = row.postcode

    }
  }
}
</script>

<style scoped lang="less">
.main{
  height: 100%;
  /deep/.el-dialog__headerbtn .el-dialog__close{
    color: #313131;
  }
  .topSearch{
    margin: 0 auto;
    //width: 1160px;
    height: 64px;
    padding: 0 16px;
    background: #FFFFFF;
    border-radius: 16px;
    border: 1px solid #E0E0E0;
    display: flex;
    justify-content: space-between;
    line-height: 64px;
    /deep/.changeFocus{
      border: 1px solid #DCDFE6;
      color: #606266
    }
    .searchBton{
      background-color: #1F2D42;
      color: #FFFFFF;
    }
    .searchBton:hover{
      background: #354255;
    }
  }
  .secoundBton{
    margin-top: 16px;
    text-align: right;
    .btom{
      margin-top: 16px;
      display: flex;
      justify-content: space-between;
      .innerLeft{
        font-size: 16px;
        font-family: SFPro-Regular, SFPro;
        font-weight: 400;
        color: #1F2D42;
        line-height: 20px;
      }
    }
    .addNew{
      background-color: #E95646;
      border-radius: 20px;
    }
     .addNew:hover{
           background: #CE574A;
         }
  }
  .innerTable{
    margin: 16px 0;

    img{
      width: 16px;
      margin: 0 7px;
    }
    .action{
      span{
        cursor: pointer;
      }
    }
  }
  .empty{
    width: 200px;
    height: 387px;
    margin: 20px auto;
    text-align: center;
    position: relative;
    div{
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
    h2{
      font-size: 16px;
    }
    img{
      width: 100%;
      height: 200px;
      margin: 0;
    }
  }
}

</style>
<style>
#topInput{
  border-bottom-right-radius: 20px!important;
  border-top-right-radius: 20px!important;
}
#topInputs{
  border-bottom-right-radius: 20px!important;
  border-top-right-radius: 20px!important;
}
#allInput{
  border-radius: 20px;
}
#borderTop{
  border-top-left-radius: 20px!important;
  border-top-right-radius: 20px!important;
}
#borderBtom{
  border-bottom-left-radius: 20px!important;
}
#borderBtoms{
  border-bottom-right-radius: 20px!important;
}
</style>
